import React from 'react'
import Manager from '../../public/components/Manager'
import SupplierDiv from './SupplierDiv'
import SupplierKindClassDiv from './SupplierKindClassDiv'
import SupplierKindItemDiv from './SupplierKindItemDiv'
Ext.require('Ext.Toast')


const config = {
    buttons: [
    ],
    columns: [
        { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
        { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, flex: 1, },
        { _text: '公司地址', field: 'Address', search: true, minWidth: 150, flex: 1, },
        { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150, flex: 1, },
        { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, flex: 1, },
        { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, flex: 1, },
        { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
        { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
        { _: 'taskName', field: 'Task.TaskName' }
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} taskName={data.taskName} readOnly={true} search={true}/>),
}

export default props => <Manager {...props} config={config} />